import React, { useState } from "react";
import Image from "next/image";
import { useRouter } from "next/router";
import { IoMenu, IoClose } from "react-icons/io5";
import MotionSection from "components/section/MotionSection";
import PredictorsCarousel from "components/carousel/PredictorsCarousel";
import { categories } from "./constants";

const PredictorsContainer = ({ updatedPredictors }) => {
  const router = useRouter();
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);

  return (
    <div
      style={{ fontFamily: "Noto Sans Armenian" }}
      className="w-full my-2 md:my-4 overflow-hidden"
    >
      <MotionSection
        animationVariants={{
          hidden: { y: 30, opacity: 0 },
          visible: { y: 0, opacity: 1, transition: { duration: 0.6 } },
        }}
      >
        <div className="mb-5 w-full">
          <div className="flex justify-between items-center px-2">
            <h2 className="text-2xl md:text-3xl text-slate-900 dark:text-white font-bold tracking-tight">
              Կանխատեսողներ
            </h2>
            <button
              onClick={() => setIsFiltersOpen(!isFiltersOpen)}
              className="text-2xl text-slate-500 hover:text-[#0033FF] transition-colors p-2 rounded-xl"
            >
              {isFiltersOpen ? <IoClose /> : <IoMenu />}
            </button>
          </div>
          <div
            className={`flex-wrap gap-3 mt-4 transition-all ${isFiltersOpen ? "flex" : "hidden"}`}
          >
            {categories.map((category) => {
              return (
                <div
                  onClick={() =>
                    router.push({
                      pathname: "/predictors",
                      query: { categories: category.id },
                    })
                  }
                  key={category.title}
                  className="flex items-center gap-2.5 rounded-full px-4 py-2 bg-[#f0f4ff] dark:bg-slate-800 hover:bg-[#0033FF] hover:text-white text-slate-700 dark:text-slate-200 transition-all cursor-pointer text-xs md:text-sm font-semibold"
                >
                  <Image
                    width={20}
                    height={20}
                    src={category.icon}
                    alt="category"
                    priority
                  />
                  <span>{category.title}</span>
                </div>
              );
            })}
          </div>
        </div>
        <PredictorsCarousel slides={updatedPredictors} />
      </MotionSection>
    </div>
  );
};

export default PredictorsContainer;
